module.exports = __webpack_public_path__ + "static/media/gb-sct.5a186492.svg";